import { Box, Typography, useTheme } from "@mui/material";
import Error from "~components/Templates/Error";
import NotFoundImage from "~assets/not-found-image.png";

type Props = {
  isSigned?: boolean;
};

const NotFound = ({ isSigned }: Props) => {
  const theme: any = useTheme();
  return (
    <Error isSigned={isSigned}>
      <Box
        component="img"
        sx={{ height: 168, width: 168 }}
        src={NotFoundImage}
      />
      <Typography
        variant="body1"
        component="span"
        sx={{ color: theme.palette.common.white }}
      >
        ihhh... não conseguimos encontrar sua página
      </Typography>
    </Error>
  );
};

export default NotFound;
